//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Annotations.js";
import "../no/TaggedObject.js";
let d=[[[0,"AllowManualRows",1,0],[0,"AutomaticUpdate",1,0],[0,"CalloutSuffix",1,0],[0,"CharToSkip",1,0],[0,"CreateNewRowAsLocked",1,0],[0,"EnableCrossHighlighting",1,0],[0,"GrowDirectionOptions",1,0],[0,"HighlightColor",1,0],[0,"HighlightManualText",1,0],[0,"Increment",1,0],[0,"InitialCallout",1,0],[0,"LockPartsListSetup",1,0],[0,"MainSymbolCustomText",1,0],[0,"MainSymbolText",1,0],[0,"PackRoutedStockComponents",1,0],[0,"ReferenceSymbolCustomText",1,0],[0,"ReferenceSymbolText",1,0],[0,"ShowLockedDeletedRows",1,0],[0,"ShowReferenceCalloutSuffix",1,0],[0,"SortOnUpdate",1,0],[0,"Symbol",1,0],[0,"VerticalGroupAttachment",1,0]],[[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.Annotations.PartsListBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Annotations.PartsListBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Annotations.PartsListBuilder.PartsListGrowDirectionOptions = Object.freeze({
    "Up" : "Up", "Down" : "Down"});

SPLM.Annotations.PartsListBuilder.PartsListVerticalGroupLeaderAttachment = Object.freeze({
    "Top" : "Top", "Bottom" : "Bottom"});

SPLM.Annotations.PartsListBuilder.PartsListShowLockedDeletedRows = Object.freeze({
    "Strikethrough" : "Strikethrough", "Blanked" : "Blanked", "Hidden" : "Hidden", "Ordinary" : "Ordinary"});

SPLM.Annotations.PartsListBuilder.PartsListSymbolType = Object.freeze({
    "None" : "None", "Circle" : "Circle", "DividedCircle" : "DividedCircle", "TrianglePointedDown" : "TrianglePointedDown", "TrianglePointedUp" : "TrianglePointedUp", "Square" : "Square", "DividedSquare" : "DividedSquare", "Hexagon" : "Hexagon", "DividedHexagon" : "DividedHexagon", "QuadrantCircle" : "QuadrantCircle", "RoundedBox" : "RoundedBox", "Underline" : "Underline", "NoSymbol" : "NoSymbol", "Label" : "Label"});

SPLM.Annotations.PartsListBuilder.PartsListMainSymbolText = Object.freeze({
    "None" : "None", "Callout" : "Callout", "PartName" : "PartName", "CalloutandQuantity" : "CalloutandQuantity", "Custom" : "Custom"});

SPLM.Annotations.PartsListBuilder.PartsListReferenceSymbolText = Object.freeze({
    "None" : "None", "Callout" : "Callout", "PartName" : "PartName", "CalloutandQuantity" : "CalloutandQuantity", "Custom" : "Custom"});

export default SPLM;